// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9aad7125","977":"83aac2ce"}[chunkId] + ".chunk.js";
};